export default {
  API_URL: 'https://nged-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://ngedsandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
